
import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import {L10n} from '~commonInfra/L10n/L10n';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { DeleteDataConnectPoolDialogBody, DeleteDataConnectPoolDialogProps, DeleteDataConnectPoolDialogState } from '~src/settings/dataconnect-settings/sections/dataConnectMultiPool/DeleteDataConnectPoolDialog';
import { IDeleteBaasEdgePoolResult } from '~src/settings/dataconnect-settings/serverApi/requests/DeleteBaasEdgePoolRequest';
import { BaasEdgePoolAndCluster } from '~src/settings/dataconnect-settings/serverApi/resources/BaasEdgePoolAndCluster';

import { ActionItemInfo } from '../MoreActionsMenu';
import { Domain } from '../types/Domain';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';

export function openDeletePoolDialog(actionItem: ActionItemInfo, refreshEdgePools: () => void) {
  const action = (bodyProps: DeleteDataConnectPoolDialogProps, dialogState: DeleteDataConnectPoolDialogState) => {

    return BaasEdgePoolAndCluster.deleteBaasPools({ poolId: actionItem.poolId, clusterId: actionItem.clusterId})
      .then((result: IDeleteBaasEdgePoolResult) => {
        refreshEdgePools();
        if (result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsDeletePoolSuccess({ POOL_NAME: L10n.elideIfLong(actionItem.poolName) }) });
        }
        if (result.errors) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
          });
        }
        return Promise.resolve({});
      });
  };

  const domains: Domain[] = Object.values(actionItem.domains);

  const dialogInstance = openReactActionDialog<DeleteDataConnectPoolDialogProps, DeleteDataConnectPoolDialogState, IResult>({
    title: Messages.dataConnectSiteSettingsDeletePool(),
    bodyComponent: DeleteDataConnectPoolDialogBody,
    initialBodyProps: {
      poolName: actionItem.poolName,
      hasNodes: false,
      hasDomains: domains.length > 0,
      domains: domains
    },
    initialDialogState: {isPending: false},
    actionName: Messages.deleteMessage(),
    action: action,
    isActionDelete: true,
    dismissDialogOnActionFailed: true,
    dialogWidth: TabDialogWidth.width375px
  });

  return Promise.resolve(dialogInstance.result);
}